{
  "app": {
    "name": "SignMeOut",
    "tagline": "كل طفل يُسلَّم أو يصل إلى بيته، بتأكيد."
  },
  "nav": {
    "main": "القائمة الرئيسية",
    "dismissal": "الانصراف",
    "students": "الطلاب",
    "users": "المستخدمون",
    "messages": "الرسائل",
    "reports": "التقارير",
    "audit": "سجل النشاط",
    "settings": "الإعدادات",
    "today": "اليوم",
    "people": "المخوَّلون بالاستلام",
    "changes": "التغييرات",
    "history": "السجل",
    "account": "الحساب",
    "more": "المزيد",
    "peopleShort": "المخوّلون",
    "userMenu": "قائمة الحساب"
  },
  "common": {
    "loading": "جارٍ التحميل…",
    "cancel": "إلغاء",
    "save": "حفظ",
    "edit": "تعديل",
    "remove": "إزالة",
    "close": "إغلاق",
    "clear": "مسح",
    "more": "إجراءات أخرى",
    "choose": "اختر…",
    "listSep": "، ",
    "back": "رجوع"
  },
  "auth": {
    "lede": "سجّل الدخول لإدارة استلام الطلاب والانصراف.",
    "withPhone": "الجوال",
    "withEmail": "البريد الإلكتروني",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "phone": "رقم الجوال",
    "phoneHint": "بالصيغة الدولية، مثل ‎+971 50 123 4567",
    "code": "رمز من 6 أرقام",
    "codeSent": "أرسلنا رمزاً برسالة نصية إذا كان هذا الرقم مسجلاً لدى المدرسة.",
    "sendCode": "أرسل الرمز",
    "signIn": "تسجيل الدخول",
    "signOut": "تسجيل الخروج",
    "chooseSchool": "أي مدرسة؟",
    "chooseHint": "لديك حسابات في أكثر من مدرسة.",
    "aboutPlatform": "عن {{name}}",
    "or": "أو",
    "qrContinue": "المتابعة برمز QR",
    "qrTitle": "امسح لتسجيل الدخول",
    "qrHelp": "افتح كاميرا هاتفك وامسح هذا الرمز بهاتف سجّلت الدخول عليه مسبقاً، ثم اضغط «موافقة».",
    "qrExpires": "يعمل هذا الرمز لمدة {{seconds}} ثانية أخرى.",
    "qrNew": "اعرض رمزاً جديداً",
    "qrBack": "سجّل الدخول بطريقة أخرى",
    "point1": "انصراف أكثر أماناً",
    "point2": "تحديثات فورية",
    "point3": "ارتباك أقل للموظفين وأولياء الأمور",
    "qrSignInFirst": "سجّل الدخول على هذا الهاتف أولاً، ثم سيُطلب منك الموافقة على الشاشة الأخرى.",
    "qrApproveTitle": "تسجيل الدخول على شاشة أخرى؟",
    "qrApproveText": "سيتم تسجيل دخول الشاشة التي عرضت هذا الرمز باسم {{name}}.",
    "qrWarning": "وافق فقط إذا كانت تلك الشاشة أمامك مباشرة. لا توافق أبداً على رمز أرسله لك أحد.",
    "qrApprove": "موافقة",
    "qrApproved": "تم. سُجّل الدخول على الشاشة الأخرى."
  },
  "status": {
    "waiting": "بالانتظار",
    "guardian_arrived": "عند البوابة",
    "released": "تم الاستلام",
    "departed": "في الطريق للمنزل",
    "home_confirmed": "وصل المنزل",
    "absent": "غائب"
  },
  "mode": {
    "pickup": "يستلمه شخص بالغ",
    "independent": "يعود بمفرده"
  },
  "changeKind": {
    "alternate_pickup": "شخص آخر يستلم",
    "absent": "غائب",
    "independent": "يعود بمفرده",
    "pickup": "سيتم استلامه"
  },
  "via": {
    "link": "الرابط",
    "sms": "رد برسالة",
    "guardian": "ولي الأمر",
    "staff": "الموظف"
  },
  "role": {
    "admin": "مدير النظام",
    "staff": "موظف",
    "guardian": "ولي أمر"
  },
  "days": {
    "0": "الأحد",
    "1": "الإثنين",
    "2": "الثلاثاء",
    "3": "الأربعاء",
    "4": "الخميس",
    "5": "الجمعة",
    "6": "السبت"
  },
  "board": {
    "dismissalAt": "الانصراف الساعة {{time}}.",
    "live": "مباشر",
    "reconnecting": "جارٍ إعادة الاتصال",
    "notOpen": "لم يبدأ الانصراف بعد.",
    "pickDate": "عرض يوم آخر",
    "open": "بدء الانصراف",
    "reopen": "إعادة فتح الانصراف",
    "opened": "بدأ الانصراف",
    "scan": "مسح بطاقة الاستلام",
    "remaining": "من أصل {{total}} لم يغادروا بعد",
    "atGateCount": "عند البوابة",
    "walkingCount": "في الطريق للمنزل",
    "alerts": "تنبيهات",
    "alertsTitle_zero": "لا توجد تنبيهات",
    "alertsTitle_one": "طالب واحد يحتاج إلى متابعة",
    "alertsTitle_two": "طالبان يحتاجان إلى متابعة",
    "alertsTitle_few": "{{count}} طلاب يحتاجون إلى متابعة",
    "alertsTitle_many": "{{count}} طالباً يحتاجون إلى متابعة",
    "alertsTitle_other": "{{count}} طالب يحتاجون إلى متابعة",
    "resolve": "تمت المتابعة",
    "resolveTitle": "إغلاق التنبيه",
    "resolveNote": "ماذا حدث؟",
    "resolved": "تم إغلاق التنبيه",
    "emptyToday": "ابدأ الانصراف لتحميل طلاب اليوم. يبدأ تلقائياً أيضاً قبل موعد الانصراف في أيام الدوام.",
    "emptyPast": "لم يكن هناك انصراف في هذا اليوم.",
    "atGate": "عند البوابة",
    "gateEmpty": "عندما يضغط ولي الأمر «أنا هنا» يظهر أبناؤه هنا.",
    "arrivedBy": "وصل {{name}} قبل {{minutes}} دقيقة",
    "grade": "الصف {{grade}}",
    "release": "تسليم",
    "releaseToAdult": "تسليمه لشخص بالغ بدلاً من ذلك",
    "releasedToast": "تم تسليم {{name}}",
    "releasedTo": "استلمه {{name}} الساعة {{time}}",
    "leftAt": "غادر الساعة {{time}}",
    "homeAt": "وصل المنزل الساعة {{time}} (عبر {{via}})",
    "students": "الطلاب",
    "filter": {
      "active": "ما زالوا هنا",
      "waiting": "بالانتظار",
      "walking": "في الطريق",
      "done": "انتهى",
      "absent": "غائبون",
      "all": "الكل"
    },
    "search": "ابحث بالاسم",
    "gradeFilter": "تصفية حسب الصف",
    "allGrades": "كل الصفوف",
    "selected_zero": "لم يتم اختيار أحد",
    "selected_one": "تم اختيار طالب واحد",
    "selected_two": "تم اختيار طالبين",
    "selected_few": "تم اختيار {{count}} طلاب",
    "selected_many": "تم اختيار {{count}} طالباً",
    "selected_other": "تم اختيار {{count}} طالب",
    "departSelected": "السماح للمختارين بالمغادرة",
    "noneHere": "لا يوجد طلاب في هذا العرض.",
    "depart": "سماح بالمغادرة",
    "departed": "غادر {{name}} المدرسة",
    "markHome": "تأكيد الوصول",
    "markedHome": "تم تأكيد وصول {{name}}",
    "markAbsent": "تسجيل غياب",
    "markedAbsent": "تم تسجيل غياب {{name}}",
    "undo": "تراجع",
    "undoTitle": "التراجع عن الخطوة الأخيرة",
    "undoReason": "ما سبب التراجع؟",
    "undone": "أُعيد إلى الانتظار",
    "arrivedJustNow": "وصل {{name}} للتو",
    "departDone_zero": "لم يغادر أحد",
    "departDone_one": "غادر طالب واحد المدرسة",
    "departDone_two": "غادر طالبان المدرسة",
    "departDone_few": "غادر {{count}} طلاب المدرسة",
    "departDone_many": "غادر {{count}} طالباً المدرسة",
    "departDone_other": "غادر {{count}} طالب المدرسة",
    "departPartial": "غادر {{done}}، وتعذّر خروج {{failed}} (تم استلامهم أو تغيّرت حالتهم). تم تحديث القائمة.",
    "close": "إنهاء الانصراف",
    "closeConfirm": "إنهاء انصراف اليوم؟ يبقى الطلاب المنتظرون في القائمة وتستمر تنبيهاتهم.",
    "closed": "تم إنهاء الانصراف",
    "closedBadge": "منتهٍ",
    "scanShort": "مسح البطاقة",
    "title": "الانصراف",
    "liveAt": "الانصراف الساعة {{time}}",
    "statStudents": "الطلاب",
    "statGate": "عند البوابة",
    "statWalking": "في الطريق للمنزل",
    "statToGo": "متبقٍ {{count}}",
    "statStill": "ما زالوا هنا"
  },
  "alert": {
    "unclaimed": "لم يُستلَم بعد. أُرسلت رسالة لأولياء الأمور.",
    "unclaimedEmergency": "ما زال بانتظار الاستلام. أُرسلت رسالة لجهات الطوارئ. اتصلوا بالعائلة.",
    "notDeparted": "يعود بمفرده لكن لم يُسجَّل خروجه بعد.",
    "home": "غادر قبل {{minutes}} دقيقة ولم يتم تأكيد وصوله.",
    "homeFinal": "لم يتم تأكيد الوصول بعد مرور {{minutes}} دقيقة.",
    "arrivedNotReleased": "شخص مخوَّل عند البوابة لكن لم يتم تسليم الطالب بعد.",
    "unclaimedNoGuardian": "لم يُستلَم، ولا يوجد ولي أمر برقم جوال، لذلك لم تُرسل أي رسالة. اتصلوا بجهات الاتصال لدى الإدارة.",
    "unclaimedNoEmergency": "ما زال بانتظار الاستلام، ولا توجد جهة طوارئ برقم جوال. اتصلوا بالعائلة الآن."
  },
  "release": {
    "title": "تسليم {{name}}",
    "who": "من سيستلم؟ قارن وجهه بالصورة.",
    "todayOnly": "لليوم فقط",
    "noPhoto": "لا توجد صورة. تحقق من الهوية.",
    "notListed": "الشخص غير موجود في القائمة",
    "overrideHelp": "لا تسلّم الطالب إلا بعد التأكد هاتفياً من ولي الأمر. سيُسجَّل ذلك في سجل النشاط.",
    "overrideName": "الاسم الكامل للمستلم",
    "overrideReason": "كيف تم التأكد؟",
    "overridePlaceholder": "اتصلت بالأم الساعة 14:10 ووافقت",
    "confirm": "تسليم إلى {{name}}",
    "confirmOverride": "تسليم إلى {{name}} (مع التسجيل)"
  },
  "scan": {
    "title": "مسح بطاقة الاستلام",
    "code": "رمز البطاقة",
    "find": "بحث",
    "useCamera": "استخدام الكاميرا",
    "stopCamera": "إيقاف الكاميرا",
    "checkFace": "تأكد أن هذا هو الشخص الذي أمامك.",
    "noPhoto": "لا توجد صورة. تحقق من الهوية قبل التسليم.",
    "noChildren": "هذا الشخص غير مخوَّل باستلام أي طالب اليوم."
  },
  "today": {
    "dismissal": "الانصراف الساعة {{time}} • تُقبل تغييرات اليوم نفسه حتى الساعة {{cutoff}}.",
    "imHere": "أنا هنا",
    "imHereFor": "أبلغ البوابة بوصولك لاستلام {{names}}",
    "arrivedToast": "تم إبلاغ البوابة بوصولك",
    "noChildren": "لا يوجد أبناء مرتبطون بحسابك بعد. يرجى التواصل مع إدارة المدرسة.",
    "notStarted": "لم يبدأ",
    "confirmHome": "{{name}} وصل المنزل",
    "confirmedToast": "تم تأكيد الوصول",
    "changeToday": "تغيير اليوم",
    "passTitle": "بطاقة الاستلام الخاصة بك",
    "passHelp": "اعرض هذا الرمز عند البوابة، فيمسحه الموظف ويرى صورتك.",
    "showPass": "عرض البطاقة",
    "hidePass": "إخفاء البطاقة",
    "notOpenYet": "لم يبدأ انصراف اليوم بعد.",
    "planChange": "خطط لتغيير",
    "line": {
      "arrived": "وصلت الساعة {{time}}",
      "released": "استلمه {{name}} الساعة {{time}}",
      "departed": "غادر المدرسة الساعة {{time}}",
      "home": "وصل المنزل الساعة {{time}}",
      "arrivedOther": "وصل/ت {{name}} الساعة {{time}}"
    },
    "closed": "أنهت المدرسة انصراف اليوم.",
    "noUpdates": "لا توجد تحديثات اليوم بعد.",
    "details": "تفاصيل {{name}}",
    "planChangeLong": "خطط لتغيير في يوم آخر"
  },
  "people": {
    "title": "المخوَّلون بالاستلام",
    "lede": "لا يستطيع استلام أبنائك إلا الأشخاص المذكورون هنا. أضف صورة واضحة للوجه لكل منهم.",
    "add": "إضافة شخص",
    "edit": "تعديل البيانات",
    "empty": "لم تتم إضافة أحد بعد.",
    "you": "أنت",
    "emergency": "جهة طوارئ",
    "needsPhoto": "أضف صورة ليتعرّف عليه الموظفون.",
    "addPhoto": "إضافة صورة",
    "changePhoto": "تغيير الصورة",
    "photoSaved": "تم حفظ الصورة",
    "pass": "بطاقة الاستلام",
    "passFor": "بطاقة الاستلام لـ {{name}}",
    "passShare": "أرسل له لقطة شاشة من هذه البطاقة ليعرضها عند البوابة.",
    "removeConfirm": "إزالة {{name}}؟ لن يتمكن بعد ذلك من استلام أبنائك.",
    "removed": "تمت الإزالة",
    "fullName": "الاسم الكامل",
    "relationship": "صلة القرابة",
    "relationshipHint": "مثل: الجدة، السائق، الجار",
    "phone": "رقم الجوال",
    "forWhich": "مخوَّل باستلام",
    "emergencyHelp": "جهة طوارئ: تُرسل له رسالة إذا لم يستلم أحد الطالب"
  },
  "changes": {
    "title": "التغييرات",
    "lede": "أبلغ المدرسة بخطة مختلفة ليوم معين. تغييرات اليوم نفسه تُقبل حتى الساعة {{cutoff}}، وبعدها يرجى الاتصال بالإدارة.",
    "which": "الأبناء (اختر)",
    "date": "التاريخ",
    "what": "ما التغيير؟",
    "who": "من سيستلم؟",
    "whoHint": "أضف الأشخاص الجدد أولاً من صفحة المخوَّلين بالاستلام.",
    "note": "ملاحظة للموظفين (اختياري)",
    "submit": "حفظ التغيير",
    "saved": "تم حفظ التغيير",
    "upcoming": "التغييرات القادمة",
    "none": "لا توجد تغييرات مخطط لها.",
    "cancel": "إلغاء التغيير",
    "cancelled": "تم إلغاء التغيير",
    "cancelConfirm": "إلغاء هذا التغيير؟",
    "requestTitle": "طلب تغيير",
    "ledeShort": "أبلغ المدرسة بخطة مختلفة ليوم معين.",
    "important": "مهم",
    "rule1": "تغييرات اليوم نفسه تُقبل حتى الساعة {{cutoff}}.",
    "rule2": "بعدها يرجى الاتصال بإدارة المدرسة.",
    "rule3": "أضف الأشخاص الجدد أولاً من صفحة المخوَّلين بالاستلام.",
    "choosePerson": "اختر شخصاً",
    "notePlaceholder": "أضف أي تفاصيل…"
  },
  "history": {
    "title": "السجل",
    "empty": "لا يوجد انصراف خلال آخر 60 يوماً.",
    "date": "التاريخ",
    "child": "الطالب",
    "status": "النتيجة",
    "details": "التفاصيل",
    "homeAt": "وصل المنزل الساعة {{time}}",
    "leftUnconfirmed": "غادر (لم يُؤكَّد الوصول)",
    "lede": "انصراف أبنائك خلال آخر 60 يوماً."
  },
  "confirm": {
    "question": "هل وصل {{name}} إلى المنزل؟",
    "leftAt": "غادر المدرسة الساعة {{time}}.",
    "button": "نعم، وصل بأمان",
    "done": "{{name}} في المنزل",
    "doneAt": "تم التأكيد الساعة {{time}} وإبلاغ العائلة.",
    "invalid": "هذا الرابط لم يعد صالحاً.",
    "notApplicable": "لا يوجد ما يحتاج إلى تأكيد الآن."
  },
  "students": {
    "title": "الطلاب",
    "count_zero": "لا يوجد طلاب",
    "count_one": "طالب واحد",
    "count_two": "طالبان",
    "count_few": "{{count}} طلاب",
    "count_many": "{{count}} طالباً",
    "count_other": "{{count}} طالب",
    "add": "إضافة طالب",
    "edit": "تعديل بيانات الطالب",
    "import": "استيراد ملف CSV",
    "search": "ابحث بالاسم أو الرقم",
    "showInactive": "إظهار غير المسجلين",
    "empty": "لا يوجد طلاب.",
    "name": "الاسم",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "externalId": "الرقم المدرسي",
    "grade": "الصف",
    "homeroom": "الشعبة",
    "mode": "عادةً",
    "guardians": "أولياء الأمور",
    "authorized": "المخوَّلون",
    "phone": "جوال الطالب",
    "phoneHint": "يُستخدم لرسالة «وصلت المنزل»",
    "window": "دقائق الوصول للمنزل",
    "windowHint": "اتركه فارغاً لاستخدام الإعداد العام للمدرسة",
    "notes": "ملاحظات لموظفي البوابة",
    "notesHint": "مثل: يوجد ترتيب حضانة لدى الإدارة",
    "active": "مسجّل (أزل التحديد عند مغادرة الطالب للمدرسة)",
    "inactive": "غير نشط",
    "back": "كل الطلاب",
    "recordChange": "تسجيل تغيير",
    "changeHelp": "استخدم هذا عندما يتصل ولي الأمر بعد الموعد النهائي. سيُسجَّل باسمك.",
    "changeSource": "كيف أبلغك ولي الأمر؟",
    "changeSourcePh": "اتصلت الأم الساعة 12:30",
    "addGuardian": "إضافة ولي أمر",
    "guardianHelp": "يسجّل ولي الأمر الدخول بهذا الرقم ويتلقى الرسائل عليه.",
    "noGuardians": "لا يوجد ولي أمر مرتبط، ولا يمكن تسليم الطالب عبر التطبيق.",
    "unlink": "فك الارتباط",
    "unlinkConfirm": "فك ارتباط {{name}} بهذا الطالب؟",
    "pickupPeople": "المخوَّلون بالاستلام",
    "newCode": "رمز بطاقة جديد",
    "newCodeConfirm": "إصدار رمز جديد؟ ستتوقف البطاقة الحالية عن العمل فوراً.",
    "newCodeDone": "تم إصدار رمز جديد",
    "noParents": "لا يوجد وليّ أمر",
    "open": "فتح {{name}}",
    "colStudent": "الطالب",
    "colPickup": "الانصراف"
  },
  "users": {
    "title": "المستخدمون",
    "add": "إضافة مستخدم",
    "edit": "تعديل المستخدم",
    "search": "ابحث بالاسم أو البريد أو الجوال",
    "allRoles": "كل الأدوار",
    "role": "الدور",
    "contact": "التواصل",
    "lastLogin": "آخر دخول",
    "never": "لم يسجّل الدخول",
    "language": "اللغة",
    "newPassword": "كلمة مرور جديدة",
    "passwordHint": "10 أحرف على الأقل. مطلوبة للموظفين والمديرين، ويمكن لأولياء الأمور الدخول برمز SMS.",
    "active": "يمكنه تسجيل الدخول",
    "lede": "الأشخاص الذين يمكنهم الدخول: الموظفون وأولياء الأمور وإدارة المدرسة.",
    "inactive": "غير نشط",
    "open": "تعديل {{name}}"
  },
  "messages": {
    "title": "الرسائل",
    "lede": "كل رسالة نصية أرسلها النظام أو حاول إرسالها.",
    "filter": "تصفية حسب الحالة",
    "all": "كل الرسائل",
    "empty": "لا توجد رسائل بعد.",
    "status": {
      "queued": "قيد الإرسال",
      "sent": "أُرسلت",
      "failed": "فشل الإرسال"
    },
    "retry": "إعادة المحاولة",
    "retried": "أُعيدت إلى قائمة الإرسال",
    "to": "إلى: {{who}}",
    "failedTitle": "تعذّر الإرسال",
    "template": {
      "correction": "تصحيح",
      "departed_guardian": "غادر المدرسة",
      "departed_student": "غادر المدرسة (للطالب)",
      "home_confirmed": "وصل المنزل",
      "home_reminder_student": "تذكير بتأكيد الوصول",
      "otp": "رمز الدخول",
      "released": "تأكيد الاستلام",
      "unclaimed_emergency": "لم يُستلم: جهة الطوارئ",
      "unclaimed_guardian": "لم يُستلم بعد",
      "other": "رسالة"
    }
  },
  "reports": {
    "title": "التقارير",
    "lede": "سير الانصراف يوماً بيوم.",
    "lastDays_zero": "اليوم",
    "lastDays_one": "آخر يوم",
    "lastDays_two": "آخر يومين",
    "lastDays_few": "آخر {{count}} أيام",
    "lastDays_many": "آخر {{count}} يوماً",
    "lastDays_other": "آخر {{count}} يوم",
    "empty": "لا يوجد انصراف خلال هذه الفترة.",
    "avgPickup": "متوسط الانتظار بعد الانصراف",
    "avgPickupShort": "متوسط الانتظار (دقيقة)",
    "minutes": "{{value}} دقيقة",
    "escalations": "التصعيدات",
    "overrides": "تسليم لغير المخوَّلين",
    "changes": "التغييرات",
    "students": "الطلاب",
    "unresolved": "دون إغلاق",
    "kpiDismissals": "حالات الانصراف",
    "kpiPicked": "تم استلامهم",
    "kpiWalked": "عادوا بمفردهم",
    "kpiNotReleased": "لم يُسلَّموا",
    "chartTitle": "الأطفال الذين وصلوا بأمان يومياً",
    "tip": "{{picked}} تم استلامهم · {{walked}} عادوا بمفردهم · {{absent}} غائب · {{unresolved}} لم يُسلَّموا",
    "details": "التفاصيل اليومية",
    "more": "مؤشرات أخرى",
    "chartNote_zero": "لا توجد أيام دراسية",
    "chartNote_one": "آخر يوم دراسي",
    "chartNote_two": "آخر يومين دراسيين",
    "chartNote_few": "آخر {{count}} أيام دراسية",
    "chartNote_many": "آخر {{count}} يوماً دراسياً",
    "chartNote_other": "آخر {{count}} يوم دراسي"
  },
  "audit": {
    "title": "سجل النشاط",
    "lede": "من قام بماذا ومتى. لا يمكن تعديل السجل أو حذفه.",
    "all": "كل النشاط",
    "when": "الوقت",
    "who": "المستخدم",
    "action": "الإجراء",
    "details": "التفاصيل",
    "system": "النظام",
    "more": "عرض الأقدم",
    "filter": {
      "dismissal": "الانصراف",
      "escalation": "التنبيهات والتذكيرات",
      "auth": "تسجيلات الدخول",
      "authorization": "المخوّلون بالاستلام",
      "change": "التغييرات",
      "guardian": "أولياء الأمور",
      "person": "الأشخاص",
      "user": "المستخدمون",
      "student": "الطلاب",
      "school": "الإعدادات",
      "import": "الاستيراد",
      "notification": "الرسائل"
    },
    "by": "بواسطة {{name}}",
    "changed": "تم تغيير: {{fields}}"
  },
  "settings": {
    "title": "الإعدادات",
    "saved": "تم حفظ الإعدادات",
    "school": "المدرسة",
    "nameEn": "اسم المدرسة (بالإنجليزية)",
    "nameAr": "اسم المدرسة (بالعربية)",
    "timezone": "المنطقة الزمنية",
    "timezoneHint": "مثل Asia/Dubai أو Asia/Riyadh",
    "defaultLocale": "لغة الرسائل لجهات الاتصال بدون حساب",
    "defaultLocaleHint": "يتلقى أولياء الأمور الرسائل باللغة التي اختاروها",
    "dismissal": "الانصراف",
    "schoolDays": "أيام الدوام",
    "dismissalTime": "موعد الانصراف",
    "autoOpen": "بدء الانصراف تلقائياً (قبل الموعد بـ دقائق)",
    "autoOpenHint": "اختر 0 ليبدأ في موعد الانصراف تماماً",
    "cutoff": "آخر موعد لتغييرات اليوم نفسه",
    "cutoffHint": "بعد هذا الوقت يجب على ولي الأمر الاتصال بالإدارة",
    "unclaimed": "التنبيه بعد (دقيقة)",
    "unclaimedHint": "إذا لم يُستلم الطالب خلال هذه المدة بعد الانصراف تُرسل رسالة لأولياء الأمور، ثم لجهات الطوارئ بعد ضعفها.",
    "homeWindow": "مدة الوصول للمنزل (دقيقة)",
    "homeWindowHint": "القيمة الافتراضية للطلاب الذين يعودون بمفردهم",
    "alertStaff": "تنبيه الموظفين أيضاً عند عدم تأكيد وصول الطالب للمنزل",
    "alertStaffHint": "معطّل افتراضياً: تنتهي مسؤولية المدرسة عند مغادرة الطالب. راجع الإدارة قبل التفعيل.",
    "logo": "شعار المدرسة",
    "logoHint": "يظهر في صفحة تسجيل الدخول وأعلى التطبيق. الأفضل صورة مربعة PNG أو JPEG.",
    "uploadLogo": "رفع الشعار",
    "removeLogo": "إزالة الشعار",
    "logoSaved": "تم تحديث الشعار",
    "subscription": "الاشتراك",
    "plan": "الباقة",
    "address": "عنوان مدرستك",
    "studentsUsage": "{{n}} من {{max}} طالب",
    "studentsUsageNoMax": "{{n}} طالب",
    "smsUsage": "{{n}} رسالة نصية هذا الشهر (المشمول {{included}})",
    "smsUsageNoMax": "{{n}} رسالة نصية هذا الشهر",
    "trialEnds": "تجربة مجانية حتى {{date}}",
    "trialEnded": "انتهت التجربة المجانية. تواصل معنا للاستمرار.",
    "demoNote": "هذه مدرسة تجريبية. لا شيء هنا مدفوع.",
    "welcomeTitle": "صفحة الترحيب واللون",
    "welcomeHint": "تراها العائلات على عنوان مدرستك قبل تسجيل الدخول. اترك الرسالة فارغة لاستخدام النص المعتاد.",
    "welcomeEn": "رسالة الترحيب (بالإنجليزية)",
    "welcomeAr": "رسالة الترحيب (بالعربية)",
    "brandColor": "لون المدرسة",
    "brandColorHint": "يُستخدم للشريط العلوي والعناصر البارزة. يتغير لون النص تلقائياً ليبقى واضحاً.",
    "brandDefault": "الافتراضي",
    "brandReset": "استخدم الافتراضي",
    "welcomePage": "صفحة الترحيب",
    "welcomeOpen": "افتحها في نافذة جديدة",
    "sections": {
      "school": "معلومات المدرسة",
      "schedule": "مواعيد الانصراف",
      "welcome": "رسالة الترحيب واللون",
      "import": "استيراد الطلاب وأولياء الأمور",
      "plan": "الخطة والاستخدام"
    },
    "lede": "اختر قسماً لعرضه أو تعديله."
  },
  "import": {
    "title": "استيراد الطلاب وأولياء الأمور",
    "lede": "حمّل ملف CSV يحتوي صفاً لكل طالب وولي أمره. كرر الطالب في صف آخر لإضافة ولي أمر ثانٍ. يتم تحديث الطلاب الموجودين (بنفس الرقم المدرسي).",
    "template": "تنزيل النموذج",
    "chooseFile": "اختيار ملف CSV",
    "check": "فحص الملف",
    "run": "استيراد",
    "checked": "اكتمل الفحص: {{rows}} صف، {{studentsCreated}} طالب جديد، {{studentsUpdated}} تحديث، {{guardiansLinked}} ربط لولي أمر. لم يتم حفظ شيء بعد.",
    "done": "تم الاستيراد: {{studentsCreated}} طالب جديد، {{studentsUpdated}} تحديث، {{guardiansLinked}} ربط لولي أمر.",
    "rowError": "الصف {{row}}: {{error}}"
  },
  "account": {
    "title": "الحساب",
    "languageHint": "تُستخدم للتطبيق وللرسائل التي تصلك",
    "password": "كلمة المرور",
    "current": "كلمة المرور الحالية",
    "changePassword": "تغيير كلمة المرور",
    "passwordChanged": "تم تغيير كلمة المرور",
    "sessions": "الأجهزة المتصلة",
    "sessionsHelp": "سجّل الخروج من كل الأجهزة إذا فقدت هاتفك أو استخدمت جهازاً مشتركاً.",
    "signOutAll": "تسجيل الخروج من كل الأجهزة"
  },
  "errors": {
    "generic": "حدث خطأ. حاول مرة أخرى.",
    "invalid_credentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    "invalid_code": "الرمز غير صحيح أو منتهي الصلاحية. اطلب رمزاً جديداً.",
    "unauthenticated": "انتهت الجلسة. سجّل الدخول مرة أخرى.",
    "forbidden": "ليست لديك صلاحية لهذا الإجراء.",
    "not_authorized": "هذا الشخص غير مخوَّل باستلام هذا الطالب اليوم.",
    "csrf": "أعد تحميل الصفحة وحاول مرة أخرى.",
    "not_found": "لم نعثر على المطلوب. ربما تمت إزالته.",
    "validation": "بعض البيانات ناقصة أو غير صحيحة.",
    "past_cutoff": "انتهى موعد تغييرات اليوم نفسه. يرجى الاتصال بإدارة المدرسة.",
    "past_date": "هذا التاريخ في الماضي.",
    "nothing_to_collect": "لا يوجد من أبنائك من ينتظر الاستلام الآن.",
    "session_closed": "انصراف اليوم مغلق.",
    "invalid_state": "تم تحديث هذا من قِبل شخص آخر. تم تحديث القائمة.",
    "not_independent": "يجب تسليم هذا الطالب لشخص بالغ مخوَّل.",
    "override_required": "أدخل اسم المستلم وكيف تم التأكد.",
    "person_required": "اختر من سيستلم.",
    "duplicate": "يوجد مستخدم بنفس البريد أو رقم الجوال.",
    "wrong_password": "كلمة المرور الحالية غير صحيحة.",
    "self_lockout": "لا يمكنك تعطيل حسابك أو تخفيض صلاحياته.",
    "contact_required": "أضف بريداً إلكترونياً أو رقم جوال.",
    "staff_credentials": "يحتاج الموظفون والمديرون إلى بريد إلكتروني وكلمة مرور.",
    "guardian_details": "الاسم ورقم الجوال مطلوبان.",
    "invalid_image": "استخدم صورة بصيغة JPEG أو PNG أو WebP.",
    "empty_csv": "الملف لا يحتوي على صفوف.",
    "no_file": "اختر ملفاً أولاً.",
    "FST_ERR_RATE_LIMIT": "محاولات كثيرة. انتظر دقيقة ثم حاول مجدداً.",
    "invalid_phone": "أدخل رقم الجوال بالصيغة الدولية، مثل ‎+971 50 123 4567.",
    "invalid_timezone": "المنطقة الزمنية غير معروفة. استخدم اسماً مثل Asia/Dubai.",
    "rate_limited": "محاولات كثيرة. انتظر بضع دقائق ثم حاول مجدداً.",
    "duplicate_student_id": "يوجد طالب آخر بنفس الرقم المدرسي.",
    "csv_semicolon": "الملف يستخدم الفاصلة المنقوطة. في Excel احفظه بصيغة \"CSV UTF-8 (مفصول بفواصل)\" ثم حاول مجدداً.",
    "school_suspended": "حساب هذه المدرسة متوقف مؤقتاً. يرجى التواصل مع المدرسة.",
    "invalid_ticket": "يرجى تسجيل الدخول مرة أخرى.",
    "demo_busy": "العرض التجريبي مزدحم حالياً. حاول بعد بضع دقائق.",
    "slug_taken": "هذا العنوان مستخدم لمدرسة أخرى.",
    "domain_taken": "هذا النطاق مستخدم لمدرسة أخرى.",
    "confirm_mismatch": "اكتب عنوان المدرسة كما هو تماماً للتأكيد.",
    "duplicate_user": "يوجد شخص في هذه المدرسة يستخدم هذا البريد أو الجوال.",
    "duplicate_email": "هذا البريد موجود في الفريق.",
    "cannot_remove_self": "لا يمكنك إزالة نفسك.",
    "demo_limit": "يقبل العرض التجريبي ملفات حتى 100 صف.",
    "cannot_remove_owner": "لا يمكن إزالة مالك المنصة.",
    "qr_expired": "انتهت صلاحية هذا الرمز. اعرض رمزاً جديداً على الشاشة الأخرى.",
    "qr_other_school": "هذا الرمز من صفحة دخول مدرسة أخرى."
  },
  "relation": {
    "mother": "الأم",
    "father": "الأب",
    "parent": "ولي الأمر",
    "guardian": "ولي الأمر",
    "grandmother": "الجدة",
    "grandfather": "الجد",
    "aunt": "العمة/الخالة",
    "uncle": "العم/الخال",
    "brother": "الأخ",
    "sister": "الأخت",
    "sibling": "أخ/أخت",
    "driver": "السائق",
    "nanny": "المربية",
    "babysitter": "جليسة الأطفال",
    "neighbour": "الجار",
    "neighbor": "الجار",
    "family": "العائلة",
    "family friend": "صديق العائلة",
    "stepmother": "زوجة الأب",
    "stepfather": "زوج الأم"
  },
  "demo": {
    "guardian": "وليّ أمر",
    "guardianText": "اضغط «أنا هنا»، واختر من يستلم، وخطّط لتغيير ليوم واحد.",
    "staff": "موظف البوابة",
    "staffText": "شاهد من وصل إلى البوابة، وقارن الصور، وسلّم الأطفال بثقة.",
    "admin": "إدارة المدرسة",
    "adminText": "أدِر الطلاب والمستخدمين، واطّلع على كل الرسائل، وشغّل التقارير، وحدّث الإعدادات.",
    "starting": "جارٍ تجهيز مدرستك…",
    "bar": "عرض تجريبي مباشر",
    "viewAs": "اعرض بصفة",
    "endsAt": "تُحذف الساعة {{time}}",
    "getIt": "احصل عليه لمدرستك",
    "back": "رجوع",
    "badge": "جرّبه بصفتك…",
    "heading": "جرّب {{name}} من موقعك",
    "sub": "استخدم مدرسة تجريبية جاهزة لترى كيف يعمل مع أولياء الأمور وموظفي البوابة وإدارة المدرسة.",
    "note": "مدرسة تجريبية خاصة بك فيها ستة طلاب، وانصراف اليوم مفتوح مسبقاً. لا تُرسل أي رسائل إلى هواتف حقيقية، وتُحذف بعد {{hours}} ساعات.",
    "startAs": {
      "guardian": "ابدأ بصفة وليّ أمر",
      "staff": "ابدأ بصفة موظف البوابة",
      "admin": "ابدأ بصفة إدارة المدرسة"
    }
  },
  "setup": {
    "title": "عيّن كلمة المرور",
    "welcome": "أهلاً {{name}}",
    "forSchool": "حسابك في {{school}}.",
    "password": "كلمة المرور الجديدة",
    "hint": "10 أحرف على الأقل.",
    "repeat": "أعد كتابة كلمة المرور",
    "mismatch": "كلمتا المرور غير متطابقتين.",
    "save": "عيّن كلمة المرور وسجّل الدخول",
    "invalid": "انتهت صلاحية هذا الرابط أو استُخدم من قبل. اطلب رابطاً جديداً ممن أرسله.",
    "doneSuspended": "تم تعيين كلمة المرور. يُتاح الدخول عند إعادة تفعيل حساب المدرسة."
  },
  "unavailable": {
    "notFoundTitle": "لا توجد مدرسة على هذا العنوان",
    "notFoundText": "تحقق من العنوان الذي وصلك.",
    "suspendedTitle": "{{school}} متوقفة مؤقتاً",
    "suspendedText": "تسجيل الدخول متوقف حالياً. للعائلات والموظفين: يرجى التواصل مع إدارة المدرسة. لمسؤولي المدرسة: يرجى التواصل مع {{name}}.",
    "home": "انتقل إلى {{name}}"
  },
  "landing": {
    "nav": {
      "how": "كيف يعمل",
      "pricing": "الأسعار",
      "faq": "أسئلة",
      "signIn": "تسجيل الدخول",
      "demo": "جرّب العرض",
      "menu": "القائمة",
      "features": "المزايا"
    },
    "hero": {
      "lede": "أدِر الانصراف اليومي، ودَع الأهل يتابعون أبناءهم لحظة بلحظة، وأبقِ الجميع على اطلاع فوراً.",
      "demo": "جرّب العرض المباشر",
      "book": "احجز مكالمة",
      "note": "دون تسجيل. تحصل على مدرسة تجريبية خاصة بك خلال ثانية.",
      "eyebrow": "منصة استلام الطلاب وسلامتهم",
      "titleA": "طريقة آمنة ومنظّمة ليعود كل طفل إلى بيته",
      "titleB": "بأمان.",
      "point1": "استلام أكثر أماناً",
      "point2": "تحديثات فورية",
      "point3": "أسئلة أقل"
    },
    "board": {
      "title": "لوحة البوابة",
      "live": "مباشر",
      "dismissal": "الانصراف 14:00",
      "waiting": "بالانتظار",
      "atGate": "{{name}} عند البوابة",
      "handed": "سُلّم إلى {{name}} الساعة {{time}}",
      "walking": "في الطريق إلى البيت",
      "home": "وصل الساعة {{time}}",
      "reminded": "أُرسلت رسالة للأهل",
      "kid0": "نوى حداد",
      "kid1": "آدم حداد",
      "kid2": "دانيال حداد",
      "kid3": "ليلى الخطيب",
      "kid4": "يوسف الخطيب",
      "kid5": "ميرا صالح",
      "adult0": "سارة",
      "adult1": "روث",
      "adult2": "خالد",
      "grade0": "KG2",
      "grade1": "الصف 3",
      "grade2": "الصف 8",
      "grade3": "الصف 1",
      "grade4": "الصف 10",
      "grade5": "KG2",
      "search": "ابحث بالاسم أو الصف…",
      "allGrades": "كل الصفوف",
      "notify": "تم تسليم {{child}} إلى {{adult}}. ✓",
      "stat": {
        "students": "الطلاب",
        "dismissed": "غادروا",
        "inPickup": "قيد الاستلام",
        "waiting": "بالانتظار"
      }
    },
    "journeys": {
      "title": "كيف يعمل",
      "pickup": "يستلمه وليّ الأمر",
      "walk": "يعود إلى البيت مشياً",
      "p1": "يضغط وليّ الأمر «أنا هنا» من هاتفه.",
      "p2": "يظهر الأبناء على شاشة موظف البوابة مع صورهم.",
      "p3": "يتحقق الموظف من وليّ الأمر ويسلّمه الطفل، وتصله رسالة نصية.",
      "w1": "يسمح الموظف للطلاب الأكبر سناً بالمغادرة بضغطة واحدة (صفاً كاملاً في كل مرة).",
      "w2": "تصل كل طالب رسالة فيها رابط، يضغطه أو يرد بـ 1 عند وصوله إلى البيت.",
      "w3": "لم يصل رد في الوقت المحدد؟ يُرسل تذكير، ثم يُبلَّغ الأهل.",
      "lede": "طريقة بسيطة وآمنة للاستلام، وللطلاب الذين يعودون إلى البيت بمفردهم."
    },
    "timeline": {
      "title": "عندما لا يُستلم طفل",
      "lede": "المتابعة تعمل تلقائياً، فلا يحتاج أحد عند البوابة إلى التذكّر.",
      "t0": "الانصراف",
      "t0Text": "يظهر الأطفال على لوحة البوابة، ويستطيع الأهل الضغط على «أنا هنا».",
      "t15": "بعد 15 دقيقة",
      "t15Text": "تصل رسالة للأهل: طفلك ما زال ينتظر في المدرسة.",
      "t30": "بعد 30 دقيقة",
      "t30Text": "تُرسل رسالة إلى جهات الطوارئ ويظهر تنبيه للإدارة.",
      "tEnd": "التسليم",
      "tEndText": "يُسجَّل التسليم: من استلم، ومن سلّم من الموظفين، وفي أي ساعة."
    },
    "roles": {
      "title": "نظام واحد لكل من يقف عند البوابة",
      "parents": "أولياء الأمور",
      "parentsText": "دخول برمز يصل برسالة نصية. اختر من يحق له الاستلام وأضف صورهم، وخطّط لتغييرات مثل «الجدة يوم الخميس».",
      "staff": "موظفو البوابة",
      "staffText": "الانصراف كله على شاشة واحدة، على الهاتف أو الجهاز اللوحي. قارن الوجوه قبل التسليم، وسجّل المكالمات، وتابع التنبيهات.",
      "office": "إدارة المدرسة",
      "officeText": "استورد الطلاب من جدول بيانات، وأدِر الحسابات، واطّلع على كل رسالة أُرسلت، مع سجل نشاط لا يمكن تعديله.",
      "authorized": "مخوّل بالاستلام"
    },
    "trust": {
      "title": "مصمم للمدارس",
      "arabic": "عربي وإنجليزي بالكامل: شاشات من اليمين إلى اليسار، ورسائل بلغة كل عائلة.",
      "photos": "الصور لا يراها إلا الموظفون المسجلون وعائلة الطفل نفسها.",
      "audit": "كل تسليم واستثناء وتغيير يُحفظ في سجل نشاط لا يمكن تعديله.",
      "own": "عنوان خاص بمدرستك وشعارها واسم المرسل في الرسائل.",
      "phones": "يعمل في متصفح أي هاتف ويمكن إضافته إلى الشاشة الرئيسية، دون متجر تطبيقات."
    },
    "pricing": {
      "title": "الأسعار",
      "lede": "سعر سنوي واحد لكل مدرسة حسب عدد الطلاب. كل الباقات تشمل كل المزايا.",
      "plan": "الباقة",
      "students": "الطلاب",
      "upTo": "حتى {{n}}",
      "anyNumber": "أي عدد",
      "perYear": "سنوياً",
      "custom": "لنتحدث",
      "sms": "رسائل نصية مشمولة شهرياً",
      "smsCustom": "حسب الاتفاق",
      "extras": "يشمل أيضاً",
      "setup": "رسوم تجهيز لمرة واحدة {{amount}}: نستورد طلابك وندرّب موظفي البوابة.",
      "overage": "الرسائل الزائدة عن المشمول بسعر {{amount}} للرسالة.",
      "trial": "تبدأ كل مدرسة بتجربة مجانية لمدة {{days}} يوماً.",
      "choose": "احجز مكالمة",
      "features": {
        "all_features": "كل المزايا",
        "email_support": "دعم بالبريد",
        "priority_support": "دعم ذو أولوية",
        "own_logo": "شعار مدرستك",
        "own_domain": "نطاقك الخاص",
        "sender_id": "اسم المرسل الخاص بك",
        "dedicated": "خيار استضافة مخصصة",
        "account_manager": "مدير حساب"
      },
      "badge": "الأسعار",
      "titleA": "أسعار بسيطة و",
      "titleB": "واضحة",
      "titleC": " للمدارس",
      "studentsUpTo": "حتى {{n}} طالب",
      "anyStudents": "أي عدد من الطلاب",
      "perYearShort": "سنوياً",
      "textsPerMonth": "{{n}} رسالة نصية شهرياً",
      "popular": "الأكثر طلباً",
      "trialTitle": "تجربة مجانية {{days}} يوماً",
      "trialText": "لكل مدرسة.",
      "setupTitle": "رسوم تجهيز لمرة واحدة {{amount}}:",
      "setupText": "نستورد طلابك وندرّب موظفي البوابة.",
      "overageTitle": "الرسائل الإضافية:",
      "overageText": "{{amount}} للرسالة بعد الحد الشهري."
    },
    "faq": {
      "title": "أسئلة تطرحها المدارس",
      "q1": "هل يحتاج الأهل إلى تثبيت تطبيق؟",
      "a1": "لا. يعمل في متصفح الهاتف ويمكن إضافته إلى الشاشة الرئيسية كأنه تطبيق. ويدخل الأهل برمز يصلهم برسالة نصية.",
      "q2": "ماذا لو لم يكن لدى ولي الأمر هاتف ذكي؟",
      "a2": "يستطيع الموظف تسليم الطفل لأي شخص في قائمة المخوّلين، وتسجيل التغييرات التي تصل بالهاتف إلى الإدارة. والرسائل النصية تصل إلى أي هاتف.",
      "q3": "من يستطيع رؤية بياناتنا؟",
      "a3": "موظفو مدرستك فقط، وكل عائلة ترى أبناءها فقط. بيانات كل مدرسة منفصلة، والصور ليست عامة أبداً.",
      "q4": "هل نستطيع استخدام نطاقنا وشعارنا؟",
      "a4": "نعم. لكل مدرسة عنوان خاص لدينا، ويمكنها أيضاً استخدام نطاقها وشعارها واسم المرسل الخاص بها.",
      "q5": "كم يستغرق البدء؟",
      "a5": "عادة يوم أو يومان. أرسل لنا قائمة الطلاب في جدول بيانات، فنستوردها وندرّب موظفي البوابة."
    },
    "contact": {
      "title": "احجز مكالمة",
      "lede": "أخبرنا عن مدرستك. نرد خلال يوم عمل واحد.",
      "name": "اسمك",
      "email": "بريد العمل",
      "phone": "الهاتف (اختياري)",
      "school": "المدرسة",
      "students": "عدد الطلاب",
      "message": "هل هناك ما نحتاج معرفته؟ (اختياري)",
      "send": "أرسل الطلب",
      "sent": "شكراً. سنتواصل معك خلال يوم عمل واحد."
    },
    "footer": {
      "schoolSignIn": "دخول المدارس",
      "console": "لوحة التحكم",
      "rights": "© {{year}} {{name}}"
    }
  },
  "platform": {
    "title": "لوحة التحكم",
    "signIn": "الدخول إلى لوحة التحكم",
    "lede": "لفريق {{name}}.",
    "nav": {
      "schools": "المدارس",
      "leads": "طلبات العرض",
      "team": "الفريق"
    },
    "kpi": {
      "schools": "المدارس",
      "active": "مدفوعة",
      "trial": "في التجربة",
      "suspended": "متوقفة",
      "students": "الطلاب",
      "sms": "رسائل هذا الشهر",
      "arr": "الإيراد السنوي",
      "leads": "طلبات جديدة",
      "demos": "عروض تجريبية جارية"
    },
    "status": {
      "trial": "تجربة",
      "active": "فعّالة",
      "suspended": "متوقفة"
    },
    "col": {
      "school": "المدرسة",
      "plan": "الباقة",
      "status": "الحالة",
      "students": "الطلاب",
      "sms": "رسائل هذا الشهر",
      "lastActive": "آخر نشاط"
    },
    "search": "ابحث في المدارس",
    "addSchool": "إضافة مدرسة",
    "noSchools": "لا توجد مدارس بعد. أضف أول مدرسة.",
    "never": "لم يحدث",
    "overLimit": "تجاوزت حد الباقة",
    "trialEnded": "انتهت التجربة",
    "smsOver": "{{n}} فوق المشمول",
    "form": {
      "profile": "المدرسة",
      "name": "الاسم (بالإنجليزية)",
      "nameAr": "الاسم (بالعربية)",
      "slug": "عنوان الويب",
      "slugTaken": "مستخدم مسبقاً",
      "timezone": "المنطقة الزمنية",
      "locale": "اللغة الافتراضية",
      "dismissal": "موعد الانصراف",
      "billing": "الباقة والفوترة",
      "plan": "الباقة",
      "startAs": "البدء بحالة",
      "trialDays": "مدة التجربة (أيام)",
      "trialEndsAt": "نهاية التجربة",
      "status": "الحالة",
      "branding": "العنوان والرسائل",
      "customDomain": "نطاق المدرسة الخاص (اختياري)",
      "customDomainHint": "مثل pickup.myschool.org. تضيف المدرسة سجل CNAME يشير إلى {{target}}.",
      "smsSender": "اسم المرسل في الرسائل (اختياري)",
      "smsSenderHint": "معرّف مرسل مسجّل مثل ALNOOR أو رقم. اتركه فارغاً لاستخدام المرسل العام.",
      "contact": "جهة الفوترة",
      "contactName": "الاسم",
      "contactEmail": "البريد",
      "contactPhone": "الهاتف",
      "notes": "ملاحظات خاصة",
      "notesHint": "لا يراها إلا فريقك.",
      "admin": "أول مسؤول في المدرسة",
      "adminHint": "يصله رابط لتعيين كلمة المرور.",
      "adminName": "الاسم الكامل",
      "adminEmail": "البريد",
      "adminPhone": "الجوال (اختياري)",
      "create": "إنشاء المدرسة",
      "save": "حفظ التغييرات",
      "saved": "تم الحفظ"
    },
    "link": {
      "title": "رابط الدخول لـ {{name}}",
      "text": "أرسل هذا الرابط إلى {{name}}. يتيح له تعيين كلمة مرور وتسجيل الدخول. يعمل مرة واحدة وينتهي في {{date}}.",
      "copy": "انسخ الرابط",
      "copied": "تم نسخ الرابط",
      "copyFailed": "تعذّر النسخ. حدّد الرابط وانسخه."
    },
    "detail": {
      "usage": "الاستخدام",
      "smsChart": "الرسائل المرسلة شهرياً",
      "admins": "مسؤولو المدرسة",
      "addAdmin": "إضافة مسؤول",
      "newLink": "رابط دخول جديد",
      "hasPassword": "لديه كلمة مرور",
      "noPassword": "لم يعيّن كلمة مرور",
      "visit": "افتح المدرسة",
      "activity": "تغييرات فريقك",
      "danger": "إيقاف أو حذف",
      "suspend": "إيقاف المدرسة",
      "resume": "استئناف المدرسة",
      "suspendText": "الإيقاف يُخرج كل مستخدمي المدرسة، ويوقف الانصراف التلقائي والرسائل، ويمنع الدخول حتى الاستئناف.",
      "delete": "حذف المدرسة",
      "deleteText": "يحذف المدرسة مع كل طلابها وحساباتها وصورها وسجلاتها، ولا يمكن التراجع. اكتب {{slug}} للتأكيد.",
      "deleted": "تم حذف المدرسة",
      "planPrice": "{{amount}} سنوياً",
      "planCustom": "سعر خاص",
      "back": "كل المدارس",
      "staffAccounts": "حسابات الموظفين",
      "parentAccounts": "حسابات أولياء الأمور",
      "suspendConfirm": "إيقاف {{school}}؟ سيُسجَّل خروج الجميع فيها حتى الاستئناف."
    },
    "leads": {
      "title": "طلبات العرض",
      "empty": "لا توجد طلبات بعد. تصل من النموذج في الصفحة الرئيسية.",
      "students": "{{n}} طالب",
      "status": {
        "new": "جديد",
        "contacted": "تم التواصل",
        "won": "تم الاشتراك",
        "lost": "لم يتم"
      },
      "createSchool": "إنشاء مدرسة"
    },
    "team": {
      "title": "الفريق",
      "add": "إضافة عضو",
      "name": "الاسم الكامل",
      "email": "البريد",
      "password": "كلمة مرور مؤقتة",
      "remove": "إزالة",
      "removed": "تمت الإزالة",
      "added": "تمت الإضافة",
      "you": "أنت",
      "inactive": "أُزيل",
      "audit": "سجل النشاط",
      "myAccount": "حسابي",
      "current": "كلمة المرور الحالية",
      "new": "كلمة المرور الجديدة",
      "changePassword": "تغيير كلمة المرور",
      "passwordChanged": "تم تغيير كلمة المرور",
      "removeConfirm": "إزالة {{name}} من الفريق؟",
      "owner": "المالك"
    }
  },
  "actions": {
    "auth_login": "تسجيل دخول",
    "auth_password_changed": "تغيير كلمة المرور",
    "auth_password_set": "تعيين كلمة المرور من رابط",
    "authorization_create": "إضافة شخص مخوّل",
    "authorization_revoke": "إزالة شخص مخوّل",
    "authorization_update": "تعديل شخص مخوّل",
    "change_cancel": "إلغاء تغيير",
    "change_create": "تخطيط تغيير",
    "dismissal_absent": "تسجيل غياب",
    "dismissal_alert_resolved": "معالجة تنبيه",
    "dismissal_arrived": "الوصول إلى البوابة",
    "dismissal_auto_open": "بدء الانصراف تلقائياً",
    "dismissal_close": "إنهاء الانصراف",
    "dismissal_depart": "السماح بالمغادرة",
    "dismissal_home_confirmed": "تأكيد الوصول للبيت",
    "dismissal_open": "بدء الانصراف",
    "dismissal_release": "تسليم",
    "dismissal_release_override": "تسليم لشخص غير مدرج",
    "dismissal_undo": "التراجع عن تسليم",
    "guardian_link": "ربط ولي أمر",
    "guardian_unlink": "فك ربط ولي أمر",
    "import_csv": "استيراد ملف",
    "notification_retry": "إعادة إرسال رسالة",
    "person_photo": "تحديث صورة",
    "person_regenerate_code": "بطاقة استلام جديدة",
    "student_create": "إضافة طالب",
    "student_photo": "تحديث صورة طالب",
    "student_update": "تعديل طالب",
    "user_create": "إضافة مستخدم",
    "user_update": "تعديل مستخدم",
    "school_update": "تغيير الإعدادات",
    "school_logo": "رفع الشعار",
    "school_logo_removed": "إزالة الشعار",
    "school_created": "إنشاء المدرسة",
    "school_updated": "تعديل المدرسة",
    "school_suspended": "إيقاف المدرسة",
    "school_status_changed": "تغيير حالة المدرسة",
    "school_deleted": "حذف المدرسة",
    "school_admin_added": "إضافة مسؤول",
    "school_setup_link": "إنشاء رابط دخول",
    "lead_status": "تحديث طلب عرض",
    "team_added": "إضافة عضو للفريق",
    "team_removed": "إزالة عضو من الفريق",
    "demo_started": "بدء عرض تجريبي"
  },
  "welcome": {
    "title": "أهلاً بكم في {{school}}",
    "defaultMessage": "يتم استلام الطلاب والانصراف في {{school}} من خلال هذا التطبيق. اضغط «أنا هنا» عند وصولك إلى البوابة، فيجهّز الموظفون أبناءك، وتصلك رسالة لحظة تسليمهم.",
    "installCta": "أضفه إلى هاتفك",
    "howTitle": "كيف يتم الاستلام",
    "step1": "سجّل الدخول برقم جوالك. نرسل لك رمزاً برسالة نصية، دون كلمة مرور تحفظها.",
    "step2": "اختر من يحق له استلام أبنائك، وأضف صورة لكل منهم.",
    "step3": "عند الانصراف اضغط «أنا هنا» عند وصولك إلى البوابة. يتحقق الموظف من الوجه ويسلّمك أبناءك، وتصلك رسالة.",
    "walkers": "الطلاب الأكبر سناً الذين يعودون بمفردهم يؤكدون وصولهم برسالة واحدة، وإن لم يفعلوا يصلك تنبيه.",
    "installTitle": "أضفه إلى هاتفك",
    "installLede": "يعمل كأنه تطبيق، مع أيقونة المدرسة على شاشتك الرئيسية، دون متجر تطبيقات.",
    "installNow": "ثبّت التطبيق",
    "iphone": "افتح هذه الصفحة في Safari، واضغط زر المشاركة، ثم «إضافة إلى الشاشة الرئيسية».",
    "android": "افتح هذه الصفحة في Chrome، واضغط ⋮، ثم «تثبيت التطبيق» (أو «إضافة إلى الشاشة الرئيسية»).",
    "poweredBy": "يعمل بواسطة {{name}}",
    "back": "› {{school}}"
  }
}
